import titleCase from "./titleCase";
const searchName = (name: string, searchTerm: string, operator: string) => {
  if (!name) {
    return false;
  }
  if (searchTerm.trim() === "") {
    return true;
  }
  return operator === "or"
    ? name.includes(searchTerm) ||
        name.includes(searchTerm.toLowerCase()) ||
        name.includes(searchTerm.toUpperCase()) ||
        name.includes(titleCase(searchTerm))
    : !name.includes(searchTerm) &&
        !name.includes(searchTerm.toLowerCase()) &&
        !name.includes(searchTerm.toUpperCase()) &&
        !name.includes(titleCase(searchTerm));
};
export default searchName;
